import React from 'react';

import PropTypes from 'prop-types';

import IMAGES from 'modules/assets/web';

const ChatHeader = ({ trainerData }) => (
  <div className="page--header position-fixed col-md-9 ml-auto p-0">
    <img
      alt="header-background"
      className="bg-image"
      src={IMAGES.CHAT_HEADER_BACKGROUND}
    />
    <div className="header--content position-absolute text-white">
      <h1 className="main">COACH CHAT</h1>
      <p className="sub">
        Assigned Coach:
        <span className="trainer-name">{` ${trainerData.firstName} ${trainerData.lastName}`}</span>
      </p>
    </div>
  </div>
);

ChatHeader.propTypes = {
  clientData: PropTypes.object.isRequired,
  trainerData: PropTypes.object.isRequired,
};

export default ChatHeader;
